import { Component, EventEmitter, Input, Output, OnInit, OnDestroy, OnChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { IFilterConfig } from '../../../../models/filter/filter-config.model';

@Component({
  selector: 'app-more-filters',
  standalone: false,
  templateUrl: './more-filters.component.html',
  styleUrls: ['./more-filters.component.css'],
})
export class MoreFiltersComponent implements OnInit, OnDestroy, OnChanges {
  @Input() availableFilters: IFilterConfig[] = [];
  @Input() activeFilterIds: string[] = [];

  @Output() filterAdd = new EventEmitter<IFilterConfig>();

  public filteredOptions: IFilterConfig[] = [];
  public searchTerm: string = '';

  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.updateFilteredOptions();
  }

  ngOnChanges(): void {
    this.updateFilteredOptions();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public onFilterSelect(filter: IFilterConfig): void {
    if (!filter) {
      return;
    }
    this.filterAdd.emit(filter);
  }

  public onSearchChange(searchTerm: string): void {
    if (searchTerm === null || searchTerm === undefined) {
      this.searchTerm = '';
    } else {
      this.searchTerm = searchTerm;
    }
    this.updateFilteredOptions();
  }

  public isFilterActive(filter: IFilterConfig): boolean {
    if (!filter || !filter.field) {
      return false;
    }
    return this.activeFilterIds.includes(filter.field);
  }

  public getAvailableFilters(): IFilterConfig[] {
    return this.availableFilters.filter((filter) => !this.isFilterActive(filter));
  }

  private updateFilteredOptions(): void {
    const availableFilters = this.getAvailableFilters();

    if (!this.searchTerm || !this.searchTerm.trim()) {
      this.filteredOptions = availableFilters;
      return;
    }

    const term = this.searchTerm.toLowerCase();
    this.filteredOptions = availableFilters.filter((filter) => filter && filter.label && filter.label.toLowerCase().includes(term));
  }

  public trackByFilterId(index: number, filter: IFilterConfig): string {
    if (!filter || !filter.id) {
      return '';
    }
    return filter.id;
  }

  public getFilterIcon(type: string): string {
    if (!type) {
      return 'filter_list';
    }
    const iconMap: Record<string, string> = {
      text: 'text_fields',
      select: 'list',
      multi_select: 'checklist',
      date: 'event',
      date_range: 'date_range',
      number: 'numbers',
      user: 'person',
      group: 'group',
    };
    return iconMap[type] || 'filter_list';
  }

  public getFilterDescription(filter: IFilterConfig): string {
    if (!filter) {
      return 'Single selection';
    }
    if (filter.multiple) {
      return 'Multiple selection';
    }
    if (filter.searchable) {
      return 'Searchable';
    }
    return 'Single selection';
  }
}
